import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/baysgaia-site/baysgaia-site/src/components/templates/Level2Layout/Level2Layout.tsx");
